import { AuthenticationProvider } from './state/authentication/authentication-provider';
import ENV from './helpers/environment-variables';

const clientId = ENV.AUTHENTICATION_CLIENT_ID;
const tenantId = ENV.AUTHENTICATION_TENANT_ID;
const authenticationUrl = `https://login.microsoftonline.com/${tenantId}`;

export const authenticationProvider = new AuthenticationProvider(authenticationUrl, clientId);
